module.exports = __webpack_public_path__ + "static/media/boy_thinking_no_talk.5e8c6b17.gif";